import { TFunction } from 'i18next'

import { TransactionsBillsActionItem } from '../types/billsActionItem'

export enum TransactionsBillsActionType {
  Credit = 'credit',
  Duplicate = 'duplicate',
  Edit = 'edit',
  RegisterPayment = 'registerPayment',
  Void = 'void',
  VoidPayment = 'voidPayment',
}

interface GetBillsActionsProps {
  isBillPaid?: boolean
  t: TFunction
}

export const getBillsActions = ({ isBillPaid, t }: GetBillsActionsProps) => {
  const items: TransactionsBillsActionItem[] = [
    {
      children: t('transactions.table.static_actions.bills.edit'),
      id: TransactionsBillsActionType.Edit,
      value: TransactionsBillsActionType.Edit,
    },
    {
      children: t('transactions.table.static_actions.bills.credit'),
      id: TransactionsBillsActionType.Credit,
      value: TransactionsBillsActionType.Credit,
    },
    {
      children: t('transactions.table.static_actions.bills.duplicate'),
      id: TransactionsBillsActionType.Duplicate,
      value: TransactionsBillsActionType.Duplicate,
    },
    {
      children: t('transactions.table.static_actions.bills.void'),
      id: TransactionsBillsActionType.Void,
      value: TransactionsBillsActionType.Void,
    },
  ]

  if (!isBillPaid) {
    items.unshift({
      children: t('transactions.table.static_actions.bills.registerPayment'),
      id: TransactionsBillsActionType.RegisterPayment,
      value: TransactionsBillsActionType.RegisterPayment,
    })
  }

  return items
}
